/**
 * The two countries TDDA operates in, as step 1 offers them (S1.1).
 *
 * A plain module rather than an export from the Details page: Country is a value the wizard, the
 * record and the review summary all need, and reaching it through a React component dragged that
 * whole component into anything that wanted the list — including tests, which could not then run.
 */
export const COUNTRY_OPTIONS = [
  { label: "New Zealand", value: "NZ" },
  { label: "Australia", value: "AU" },
];
